// EXPERIENCIA

export function durationExperience(product): string {

  if(product.scheduling && Array.isArray(product.scheduling)) {
    return getDurationsArr(product?.additionalInfo?.tours?.options);
  } else {
    if(product?.scheduling && product?.scheduling?.duration && product?.scheduling?.duration) {
      return `${product.scheduling.duration.value} ${product?.scheduling?.duration.metric === 'HOURS' ? 'Horas.' : 'Minutos.'}`;
    }
  }

  return '';
}

export function getDurationsArr(options: any): string {
  if (!options || !Array.isArray(options)) {
    return '';
  }

  const durationsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.duration) {
      const durations = Array.isArray(option.duration)
        ? option.duration
        : [option.duration];

      durations.forEach((duration: string) => {
        if (duration && typeof duration === 'string') {
          const formattedDuration = builderDuration(duration);
          if (formattedDuration) {
            durationsSet.add(formattedDuration);
          }
        }
      });
    }
  });

  const durationsArray = Array.from(durationsSet);
  return durationsArray.join(', ');
}

export function builderDuration(timeString: string): string {
  try {
    const parts = timeString.split('-').map((part: string) => part.trim());

    if (parts.length !== 2) {
      return 'N/A';
    }

    const value = parseInt(parts[0], 10);
    const type = parts[1].toUpperCase();

    if (isNaN(value)) {
      return 'N/A';
    }

    if (type === 'DAYS' || type === 'days') {
      if (value === 1) {
        return '1 Día';
      } else {
        return `${value} Días`;
      }
    } else if (type === 'HOURS' || type === 'hours') {
      return `${value} Horas`;
    } else if(type === 'MINUTES' || type === 'minutes') {
       return `${value} minutos`;
    }

    else {
      return `${value} ${type}`;
    }
  } catch (error) {
    return 'N/A';
  }
}

export function periodsArrExperience(options: any[]): string {
    if (!options || !Array.isArray(options)) {
    return '';
  }

  const periodsSet = new Set<string>();

  options.forEach((option: any) => {
    if (option.sessions) {
      const sessions = Array.isArray(option.sessions)
        ? option.sessions
        : [option.sessions];

      sessions.forEach((session: string) => {
        if (session && typeof session === 'string') {
          const period = getTimePeriod(session);
          if (period) {
            periodsSet.add(period);
          }
        }
      });
    }
  });

  // Ordenar los periodos: mañana, tarde, noche
  const periodOrder: { [key: string]: number } = {
    'mañana': 1,
    'tarde': 2,
    'noche': 3
  };

  const periodsArray = Array.from(periodsSet).sort((a: string, b: string) =>
    periodOrder[a] - periodOrder[b]
  );

  return periodsArray.join(', ');
}

export function getTimePeriod(timeString: string): string {
  try {
    const [hours, minutes] = timeString.split(':').map((part: string) => Number(part));

    if (isNaN(hours) || isNaN(minutes)) {
      return 'mañana';
    }

    if (hours < 12) {
      return 'mañana';
    } else if (hours < 19) {
      return 'tarde';
    } else {
      return 'noche';
    }
  } catch (error) {
    return 'mañana';
  }
}

export function languageArrayExperience(options: any): string[] {
  if (!options || !Array.isArray(options)) {
    return [];
  }

  const languagesSet = new Set<string>();

  options.forEach((option: any) => {

    const languages = option.language || option.options || [];
    if (languages) {
      if (Array.isArray(languages)) {
        languages.forEach((lang: string) => {
          languagesSet.add(lang);
        });
      } else {
        languagesSet.add(languages);
      }
    }
  });

  return Array.from(languagesSet);
}

export function flagByLanguageNameExperience(languageName: string): string {
  const languageMap: { [key: string]: string } = {
    // Inglés
    'english': 'assets/icons/flag-results/um.svg',
    'inglés': 'assets/icons/flag-results/um.svg',
    'ingles': 'assets/icons/flag-results/um.svg',

    // Español
    'spanish': 'assets/icons/flag-results/es.svg',
    'español': 'assets/icons/flag-results/es.svg',
    'espanol': 'assets/icons/flag-results/es.svg',
    'castellano': 'assets/icons/flag-results/es.svg',

    // Francés
    'french': 'assets/icons/flag-results/fr.svg',
    'francés': 'assets/icons/flag-results/fr.svg',
    'frances': 'assets/icons/flag-results/fr.svg',
    'Francés': 'assets/icons/flag-results/fr.svg',

    // Alemán
    'german': 'assets/icons/flag-results/de.svg',
    'alemán': 'assets/icons/flag-results/de.svg',
    'aleman': 'assets/icons/flag-results/de.svg',

    // Italiano
    'italian': 'assets/icons/flag-results/it.svg',
    'italiano': 'assets/icons/flag-results/it.svg',

    // Portugués
    'portuguese': 'assets/icons/flag-results/pt.svg',
    'portugués': 'assets/icons/flag-results/pt.svg',
    'portugues': 'assets/icons/flag-results/pt.svg',

    // Chino - AGREGAR TODAS LAS VARIACIONES CON/SIN TILDES
    'chino mandarín': 'assets/icons/flag-results/cn.svg',
    'chino mandarin': 'assets/icons/flag-results/cn.svg',
    'chino': 'assets/icons/flag-results/cn.svg',
    'mandarín': 'assets/icons/flag-results/cn.svg',
    'mandarin': 'assets/icons/flag-results/cn.svg',
    'chino-mandarin': 'assets/icons/flag-results/cn.svg',
    'chino-mandarín': 'assets/icons/flag-results/cn.svg',
  };

  const normalizedLang = languageName.toLowerCase().trim();
  return languageMap[normalizedLang] || 'flag';
}


export function getExtrasExperience(extras: any): any[] {
  if (!extras || !Array.isArray(extras) || extras.length === 0) {
    return [];
  }

  // Mapa de tipos a sus configuraciones
  const typeConfig: Record<string, { image: string; tooltip: string }> = {
    'Cargo de Traslado': {
      image: '/assets/img/app/categories-search-box/bus.svg',
      tooltip: 'Traslados'
    },
    'Attractions': {
      image: '/assets/icons/search-box/atracciones.svg',
      tooltip: 'Atracciones'
    },
    'Hotel Supplements': {
      image: '/assets/icons/search-result/hotel/icono_sugerencias.svg',
      tooltip: 'Suplementos de hotel'
    }
  };
  // Usar un Set para evitar duplicados por tipo
  const seenTypes = new Set<string>();
  const result: any[] = [];

  for (const extra of extras) {
    const type = extra?.type || extra?.name || extra?.description; // Ajusta según la estructura de tu objeto

    if (type && typeConfig[type] && !seenTypes.has(type)) {
      seenTypes.add(type);
      result.push({
        type: type,
        image: typeConfig[type].image,
        tooltip: typeConfig[type].tooltip,
        // originalData: extra // Opcional: si necesitas los datos originales
      });
    }
  }

  return result;
}
